export const VALIDATION_REGEX = {
  EMAIL: '^([a-zA-Z0-9_\\-\\.\\+]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,6})$',
  PASSWORD: '^.{6,}$',
  PROPERTY_NAME: '^[a-zA-Z0-9 _-]*$',
  UNIT_TYPE_NAME: '^[a-zA-Z0-9 _-]*$',
  PROPERTY_DESCRIPTION: '^[a-zA-Z0-9 _-]*$',
  AREA_NAME: '^[a-zA-Z0-9 _-]*$',
  AMENITY_NAME: '^[a-zA-Z0-9 _-]*$'
};
